// extracted by mini-css-extract-plugin
export default {"blogCard":"BlogCard_blogCard__Yz+Qd"};